import * as React from 'react';
const DrawerContext = /*#__PURE__*/React.createContext(null);
export const RefContext = /*#__PURE__*/React.createContext({});
export default DrawerContext;